import { t } from 'ember-intl';
import { variation } from 'ember-launch-darkly';
import { MaintenanceModeOfflineService } from 'core/components';

<template>
  {{#if (variation "hcp-ui-maintenance-mode-census")}}
    <MaintenanceModeOfflineService
      @serviceName={{t "page-title.license-utilization-reporting.reports"}}
    />
  {{else}}
    {{outlet}}
  {{/if}}
</template>
